import { useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { DASHBOARD_PATH, SETUP_MFA_PATH } from 'config';
import { GuardProps } from 'types';
import { useEffect } from 'react';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

const GuestGuard = ({ children }: GuardProps) => {
    const { isCognitoLoggedIn, isLoggedIn, shouldSkipSetupMFA } = useAuth();
    const navigate = useNavigate();
    const storageshouldSkipSetupMFA = window.localStorage.getItem('shouldSkipSetupMFA');
    useEffect(() => {
        if (isCognitoLoggedIn) {
            console.log('guest guard effect running');
            if (!isLoggedIn && !shouldSkipSetupMFA && !storageshouldSkipSetupMFA) {
                navigate(SETUP_MFA_PATH, { replace: true });
            } else {
                navigate(DASHBOARD_PATH, { replace: true });
            }
        }
    }, [isCognitoLoggedIn, isLoggedIn, navigate, shouldSkipSetupMFA, storageshouldSkipSetupMFA]);

    return children;
};

export default GuestGuard;
